<h3 mat-dialog-title>{{'auswahl' | translate}}...</h3>
<mat-dialog-content class="mat-typography">
    <mat-selection-list #list style="overflow: hidden;" [multiple]="false">
        <mat-list-option (click)="onAreaListControlChanged(list, opt)" *ngFor="let opt of data.ref.options" [selected]="opt.selected" [value]="opt">
          {{opt.item.title}}
        </mat-list-option>
      </mat-selection-list>

      <div *ngIf="customDate">
        <form [formGroup]="range">
        
           <mat-form-field appearance="fill">
            <mat-label>{{'filter_date_range_items.enter_date_range' | translate}}</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input matStartDate formControlName="startDate" placeholder="Start date">
              <input matEndDate formControlName="endDate" placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker>
              <mat-datepicker-actions>
                <button mat-button class="second-btn" matDatepickerCancel>Cancel</button>
                <button mat-raised-button matDatepickerApply class="first-btn" (click)="setCustomDate(list)">Apply</button>
              </mat-datepicker-actions>
            </mat-date-range-picker>
          
            <mat-error *ngIf="range.controls.startDate.hasError('matStartDateInvalid')">Invalid start date</mat-error>
            <mat-error *ngIf="range.controls.endDate.hasError('matEndDateInvalid')">Invalid end date</mat-error>
          </mat-form-field>
          <!-- <p>Selected range: {{range.value | json}}</p> -->
          
        </form>
      </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">Ok</button>
</mat-dialog-actions>